export const state = () => ({
  nextPlaylistItem: null,
  currentContentId: null
});

export const mutations = {
  setNextPlaylistItem(state, payload) {
    state.nextPlaylistItem = payload;
  },

  setCurrentContentId(state, payload) {
    state.currentContentId = payload;
  }
};

export const actions = {
  setNextPlaylistItem({ commit }, items) {
    commit('setNextPlaylistItem', items);
  },

  setCurrentContentId({ commit }, id) {
    commit('setCurrentContentId', id);
  },

  async onClose({ state }) {
    return new Promise((resolve) => {
      window.addEventListener('message', (event) => {
        const isSameOriginMessage = event.origin.includes(window.location.host);

        if (isSameOriginMessage) {
          return;
        }

        const messageFromEngine = JSON.parse(event.data);

        const messageIsFromSameContent =
          messageFromEngine.data.contentId === state.currentContentId;

        if (messageFromEngine.event === 'onClose' && messageIsFromSameContent) {
          console.log('mesmo conteudo');
          resolve(messageFromEngine.data.isCompleted);
        }
      });
    });
  }
};
